/**
 * @功能名称: 转化给定对象的对应属性类型transfromMap:{a:Number,b:String,c:Boolean}
 * @params Object Object
 * @文件名称: transfromType.js
 * @Date: 2018/5/17 上午11:08.
 * @Author: liux
 * @Copyright（C）: 2014-2018 X-Financial Inc.   All rights reserved.
 * 注意：本内容仅限于小赢科技有限责任公司内部传阅，禁止外泄以及用于其他的商业目的。
 */
export default function(target, transfromMap) {
  for(let key in transfromMap){
    target[key] = transfromMap[key](target[key])
  }
  return target
}